// ABOUTME: Tracks the product-page catalogue button and subsequent shopping funnel.
// ABOUTME: Runs only when Shopify permits analytics; purchases are verified server-side.
// DATA FLOW: Consent -> anonymous browser/click IDs -> beacon + private cart attribute.
// DEPENDENCIES: Shopify Customer Privacy API, Ajax Cart API, native theme cart:update event.
(function () {
  if (window.__peptikNavigationAnalytics) return;
  window.__peptikNavigationAnalytics = true;
  var KEY = 'peptik_navigation_v1';
  var SESSION = 'peptik_navigation_session_v1';
  var ATTR = '__peptik_navigation_click';
  var WINDOW = 30 * 86400000;
  var state = null;
  var sid = null;
  var started = false;
  var observer;
  var shown = new WeakSet();
  var cartWrite = Promise.resolve();
  function allowed() { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
  function logError(error) { console.warn('[Peptik navigation analytics]', error.message); }
  function persist() { localStorage.setItem(KEY, JSON.stringify(state)); }
  function acquisitionSource() {
    var source = new URLSearchParams(location.search).get('utm_source');
    if (source) return source;
    if (document.referrer) {
      try { var host = new URL(document.referrer).hostname; if (host !== location.hostname) return host; } catch (_) {}
    }
    return 'Direct';
  }
  function activeClick() {
    return state?.click && Date.now() - state.click.at < WINDOW ? state.click.id : '';
  }
  function send(type, id) {
    if (!allowed() || !state || !sid) return;
    var clickId = activeClick();
    if (type !== 'click' && type !== 'impression' && !clickId) return;
    var event = { id: id || crypto.randomUUID(), type: type, vid: state.vid, sid: sid, clickId: clickId,
      path: location.pathname, device: /iPad|Tablet/i.test(navigator.userAgent) ? 'Tablet' : /Mobi|Android/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop', source: state.source };
    fetch('https://peptikelite.com/api/peptik/navigation-analytics', {
      method: 'POST', credentials: 'omit', keepalive: true,
      headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(event),
    }).then(function (r) { if (!r.ok) throw new Error('Event rejected: ' + r.status); }).catch(logError);
  }
  function stampCart(value) {
    // Serialize this feature's writes so an older click cannot overwrite a newer one.
    cartWrite = cartWrite.then(async function () {
      var attributes = {}; attributes[ATTR] = value;
      var response = await fetch((Shopify.routes?.root || '/') + 'cart/update.js', {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attributes }),
      });
      if (!response.ok) throw new Error('Cart attribution rejected: ' + response.status);
    }).catch(logError);
  }
  function pageView() {
    if (/\/collections\//.test(location.pathname)) send('catalogue_view');
    else if (/\/products\//.test(location.pathname)) send('product_view');
    else if (/\/cart\/?$/.test(location.pathname)) send('cart_view');
  }
  function start() {
    if (!allowed()) return;
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      var hadClick = Boolean(saved?.click);
      state = saved && Date.now() - saved.at < WINDOW ? saved : { vid: crypto.randomUUID(), at: Date.now(), click: null, source: acquisitionSource() };
      if (state.click && !activeClick()) state.click = null;
      persist();
      sid = sessionStorage.getItem(SESSION) || crypto.randomUUID();
      sessionStorage.setItem(SESSION, sid);
      if (state.click) stampCart(state.click.id);
      else if (hadClick) stampCart('');
    } catch (error) { state = null; logError(error); return; }
    if (started) return;
    started = true;
    pageView();
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !shown.has(entry.target) && allowed()) {
          shown.add(entry.target); send('impression');
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.peptik-other-peptides__button').forEach(function (button) { observer.observe(button); });
  }
  document.addEventListener('click', function (event) {
    if (!allowed() || !state) return;
    var button = event.target.closest('.peptik-other-peptides__button');
    if (button) {
      if (!shown.has(button)) { shown.add(button); send('impression'); }
      state.click = { id: crypto.randomUUID(), at: Date.now() };
      state.at = Date.now();
      try { persist(); } catch (error) { logError(error); }
      send('click', state.click.id);
      stampCart(state.click.id);
    } else if (event.target.closest('[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"]')) {
      send('checkout_click');
    }
  }, true);
  document.addEventListener('cart:update', function (event) {
    var data = event.detail?.data || {};
    if (!data.didError && (/product-form/.test(data.source || '') || data.source === 'add-to-cart')) {
      send('add_to_cart');
    }
  });
  document.addEventListener('visitorConsentCollected', function () {
    if (allowed()) { start(); return; }
    if (observer) observer.disconnect();
    started = false;
    shown = new WeakSet();
    state = null; sid = null;
    try { localStorage.removeItem(KEY); sessionStorage.removeItem(SESSION); } catch (error) { logError(error); }
    stampCart('');
  });
  function initializeConsent() {
    if (allowed()) { start(); return; }
    try {
      var hadAttribution = localStorage.getItem(KEY);
      localStorage.removeItem(KEY); sessionStorage.removeItem(SESSION);
      if (hadAttribution) stampCart('');
    } catch (error) { logError(error); }
  }
  if (window.Shopify?.customerPrivacy) initializeConsent();
  else if (window.Shopify?.loadFeatures) {
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) { logError(error); return; }
      initializeConsent();
    });
  }
})();
